import {
  GET_SCHOOL_LIST,
  GET_SCHOOL_SUMMARY_LIST,
  GET_SUMMARY_LIST,
  REMOVE_SCHOOLS,
  GET_STUDENT_TARGET_LIST,
  SCHOOL_ACTIVE,
  SCHOOL_DEACTIVE,
  SCHOOL_UPDATE_DESCRIPTION,
} from "../actions/SchoolActions";

const initialState = {
  schools: [],
  summary: [],
  schoolSummary: [],
  studentTarget: [],
};

const AmcReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_SCHOOL_LIST: {
      return { ...state, schools: action.payload || [] };
    }
    case GET_SUMMARY_LIST: {
      return { ...state, summary: action.payload || [] };
    }
    case GET_SCHOOL_SUMMARY_LIST: {
      return { ...state, schoolSummary: action.payload || [] };
    }
    case GET_STUDENT_TARGET_LIST: {
      return { ...state, studentTarget: action.payload || [] };
    }
    case REMOVE_SCHOOLS: {
      return { ...state };
    }
    case SCHOOL_ACTIVE: {
      return { ...state };
    }
    case SCHOOL_DEACTIVE: {
      return { ...state };
    }
    case SCHOOL_UPDATE_DESCRIPTION: {
      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
};

export default AmcReducer;